import { render, staticRenderFns } from "./editProportion.vue?vue&type=template&id=963e7e84&scoped=true&"
import script from "./editProportion.vue?vue&type=script&lang=js&"
export * from "./editProportion.vue?vue&type=script&lang=js&"
import style0 from "./editProportion.vue?vue&type=style&index=0&id=963e7e84&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "963e7e84",
  null
  
)

export default component.exports